View = require 'view'

module.exports = class UploadingLinkView extends View
  viewTitleKey: 'sending links'
  render: ->
    @$el.html('<div class="spinner loading"></div>')
    @



// WEBPACK FOOTER //
// ./app/scripts/views/card/uploading-link-view.coffee